import React from "react";
import WeAllTeamInbox from "@/components/weAllTeam/WeAllTeamInbox";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { weAllTeam } from "@/libs/routes";

/**
 * WeAll Team Messages > Inbox: every conversation, newest first, with unread counts.
 */
const WeAllTeamInboxPage = () => <WeAllTeamInbox />;

WeAllTeamInboxPage.breadCrumbArray = [
  {
    name: breadcrumb_key.weAllTeam.inbox,
    pathname: weAllTeam.inbox,
    active: true,
  },
];

export default WeAllTeamInboxPage;
